import remarkStringify from './lib/index.js'

export default remarkStringify
